
<template>
  <div class="border-btn text-center cursor-pointer" @click="selectFunction">{{ text }}</div>
</template>

<script>
export default {
  name: "border-btn",
  props: {
    // Props to receive
    // text ( type: string, required: false, description: 'String for the button')
    // selectFn ( type: Function, required: false, description: 'Function to be invoked when click')
    text: {
      type: String,
      default: "รายไตรมาส"
    },
    selectFunction: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    selectBtn(index) {
      this.selectFunction(index);
    },
    checkSelected(index) {
      return this.select === index;
    }
  }
};
</script>

<style lang='scss' scoped>
.border-btn {
  display: inline-block;
  color: $color-normal-text;
  font-size: 14px;
  text-decoration: none;
  padding: 3px 8px;
  border: 2px solid #f9f9f9;
  margin-top: 10px;
  margin-right: 5px;
  border-radius: 20px;
  background-color: #f9f9f9;
  font-weight: bold;
  font-family: DBHeaventRez;
}

@media screen and (max-width: 420px) {
  .border-btn {
    font-size: 12px;
    padding: 3px 8px;
    margin-top: 5px;
    margin-right: 5px;
  }
}
</style>
